export default __webpack_public_path__ + "static/media/logo.b3d71ddf.svg";